var map = {
	"./choose_age.mp3": 311,
	"./enfants_10.mp3": 727,
	"./enfants_11.mp3": 728,
	"./enfants_12.mp3": 729,
	"./enfants_3.mp3": 730,
	"./enfants_4.mp3": 731,
	"./enfants_5.mp3": 732,
	"./enfants_6.mp3": 733,
	"./enfants_7.mp3": 734,
	"./enfants_8.mp3": 735,
	"./enfants_9.mp3": 736,
	"./go_age.mp3": 312,
	"./splashscreen.mp3": 313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 726;